import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import { ICreateSubCategoryValidationError, IServerError, IItemForGetShortInfo } from 'types';
import classNames from 'classnames';
import style from './ModalSentErrorWithInfo.module.scss';

interface IModalSentErrorWithInfo {
	onConsentEvent: () => void;
	isVisible: boolean;
	errorResponseData: IServerError<ICreateSubCategoryValidationError> | null;
	fetchedRestaurants: IItemForGetShortInfo[];
	fetchedCategories: IItemForGetShortInfo[];
	IDSelectedCategory: Nullable<string>;
}

const ModalSentErrorWithInfo: React.FC<IModalSentErrorWithInfo> = ({
	onConsentEvent,
	isVisible,
	errorResponseData,
	fetchedRestaurants,
	fetchedCategories,
	IDSelectedCategory,
}) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const getAdditionalInfo = () => {
		return errorResponseData?.Metadata?.restaurantIds.map((el: string) => {
			const restaurantName = fetchedRestaurants.find((fetchedRestaurant) => fetchedRestaurant.id === el)?.name;
			const categoryName = fetchedCategories.find((el) => el.id === IDSelectedCategory)?.name || null;
			return (
				<React.Fragment key={el}>
					<Text
						className={style.nameWrapper}
						translationNameSpace="modals"
						translationKey="restaurantDotHaveThis"
						values={{ restaurantName }}
						components={[
							<Text
								key="1"
								translationNameSpace="modals"
								translationKey="categoryLabel"
								asFragment={true}
							/>,
						]}
						size="xxl"
						weight="bold"
						align="center"
					/>
					<div className={style.additionalInfoItems}>
						<Text
							translationKey={categoryName}
							theme="secondaryLight"
							size="l"
							weight="bold"
							align="center"
							withTooltip={true}
						/>
					</div>
				</React.Fragment>
			);
		});
	};

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<div className={style.closeIconWrapper} onClick={onConsentEvent}>
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				</div>
				<svg className={style.errorIcon}>
					<use xlinkHref={`${breadcrumbs}#error`} />
				</svg>
				<div className={style.description}>{getAdditionalInfo()}</div>
				<div className={style.btnWrapper}>
					<Button className={style.okBtn} theme="primaryBlue" onClick={onConsentEvent} type="submit">
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ModalSentErrorWithInfo);
